import styles from "./CrawlStatusPage.module.css";
import { useState, useEffect, useCallback } from "react";
import { getFailedJobs, updateFailedJobs } from "../../api/portalApi";
import AGTable from "../../components/AGTable/AGTable";
import { Button, Spinner, Modal, Form, Row, Col } from "react-bootstrap";
import FailedJobs from "./FailedJobs/FailedJobs";

const CrawlStatusPage = (props) => {
    const userEmail = props?.userEmail;

    // Data States
    const [failedJobs, setFailedJobs] = useState();
    const [detailedJobs, setDetailedJobs] = useState();
    const [startDate, setStartDate] = useState(new Date().toLocaleDateString('en-CA'));
    const [endDate, setEndDate] = useState(new Date().toLocaleDateString('en-CA'));
    const [selected, setSelected] = useState([]);
    
    // UI States
    const [filterDisabled, setFilterDisabled] = useState(true);
    const [showDetailedJob, setShowDetailedJob] = useState();
    const [loading, setLoading] = useState(false);

    const today = new Date().toLocaleDateString("en-CA", {
        timeZone: "Australia/Sydney",
    });

    // Updates selection in Table
    const onSelectionChanged = (event) => {
        setSelected(event.selectedNodes.map(node => node?.data));
    }
    const getRowId = useCallback((params) => `${params.data.spider_key}`, []);
    // Fetch Data from API
    const fetchData = useCallback(async() => {
        try {
            const res = await getFailedJobs(startDate,endDate);
            setFailedJobs(res?.data?.data);
            return res?.data?.data || [];
            
        } catch (e) {
            console.error(e);
            return []
        } 
    }, [startDate, endDate]);

    const updateJobs = async(data) => {
        setLoading(true);
        try {
            if (detailedJobs){
                setShowDetailedJob(false);
                setDetailedJobs();
                setFailedJobs();
            }
            await updateFailedJobs(data);
            const tempResults = await fetchData();
            if (detailedJobs){
                const foundJob = tempResults.find(spider => spider.spider_key === detailedJobs.spider_key);
                if (foundJob){
                    setDetailedJobs(foundJob);
                    setShowDetailedJob(true);
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleFetchData = useCallback(async() => {
        setLoading(true);
        await fetchData();
        setLoading(false);
    }, [fetchData]);

    useEffect(() => { 
        handleFetchData();
    }, [handleFetchData]);

    const handleUpdateReviewStatus = async(reviewFlag) => {
        const inputParams = selected.flatMap((spider) => {
            return spider.failed_jobs.flatMap(job => 
                (Array.isArray(job.job_key) ? job.job_key : [job.job_key]).map(key => ({
                    job_key: key,
                    reviewed: reviewFlag,
                    reviewed_by: userEmail
                }))
            );
        });
        await updateJobs(inputParams);
        setSelected([]);
    };

    let flattenedData;
    if (failedJobs){
        flattenedData = failedJobs.map((obj) => {
            return {
                ...obj,
                detailed: <Button size="sm" variant="success" onClick={() => {
                    setShowDetailedJob(true);
                    setDetailedJobs(obj);
                }}>View Details</Button>
            }
        });
    }


    return (
        <div>
            <Modal show={showDetailedJob} size="xl">
                <Modal.Header closeButton onClick={() => {
                    setShowDetailedJob(false);
                    setDetailedJobs();
                }}>
                    <Modal.Title>Details for {detailedJobs?.spider_name} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FailedJobs jobs={detailedJobs?.failed_jobs} updateJobs={updateJobs} userEmail={userEmail}/>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowDetailedJob(false);
                    setDetailedJobs();
                }}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
            <div className={styles.CrawlStatusPage}> 
                <h4>Failed Crawl Jobs</h4>
                <div className={styles.DateFilters}>
                    <Form.Group as={Row} className="align-items-end mb-3">
                        <Col sm="2">
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control 
                                type="date" 
                                max={today} 
                                value={startDate} 
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                    if (e.target.value > endDate) {
                                        setEndDate(e.target.value);
                                    }
                                    setFilterDisabled(false);
                                }}
                            />
                        </Col>
                        <Col sm="2">
                            <Form.Label>End Date</Form.Label>
                            <Form.Control 
                                type="date" 
                                max={today} 
                                value={endDate} 
                                onChange={(e) => {
                                    setEndDate(e.target.value);
                                    if (e.target.value < startDate) {
                                        setStartDate(e.target.value);
                                    }
                                    setFilterDisabled(false);
                                }}
                            />
                        </Col>
                        <Col xs="auto">
                            <Button variant="secondary" disabled={filterDisabled} onClick={handleFetchData}>
                                Apply Filters
                            </Button>
                        </Col>
                        <Col xs="auto" className="ms-auto">
                            <div className={styles.Actions}>
                                <Button variant="success" disabled={selected.length === 0} onClick={() => handleUpdateReviewStatus(true)}>
                                    Mark as Reviewed
                                </Button>
                                <Button variant="danger" disabled={selected.length === 0} onClick={() => handleUpdateReviewStatus(false)}>
                                    Mark as Unreviewed
                                </Button>
                            </div>
                        </Col>

                    </Form.Group>
                </div>
  
                {(flattenedData && !loading) && 
                    <AGTable 
                        data={flattenedData} 
                        showSelect
                        setSelected={setSelected}
                        hideFilters 
                        columnsToHide={["failed_jobs"]} 
                        fileName="failed_jobs.csv"
                        onSelectionChanged={onSelectionChanged}
                        getRowId={getRowId}
                    />
                }
                {loading && <div className={styles.spinnerContainer}>
                    <Spinner/>
                </div>}
            </div>
        </div>
    )
};

export default CrawlStatusPage;